






























































































































































































































































































































import {
  Vue, Component, Mixins, Prop
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  // @Prop() subjectId!: number
  @Prop() editData!: any;

  value = '';

  data: any[] = [];

  attachments: string[] = [];

  submitting = false;

  listloading = false;

  userInfo: { [t: string]: any } = {};

  phrases: any[] = [];

  stadiumStatus = 1;

  async mounted() {
    this.userInfo = this.$store.state.user.userInfo;

    if (this.editData.attachment) {
      if (this.editData.attachment.indexOf(',') !== -1) {
        const arr = this.editData.attachment.split(',');
        for (const img of arr) {
          this.attachments.push(this.commonUrl(img));
        }
      } else {
        this.attachments.push(this.commonUrl(this.editData.attachment));
      }
    }

    this.stadiumStatus = this.editData.stadium_status;

    this.loadData();
    this.loadPhrase();
  }

  async loadPhrase() {
    let appid = 0;
    if (this.editData.from_source === 'c') {
      appid = 1;
    } else if (this.editData.from_source === 'b') {
      appid = 2;
    }
    const res = await this.$store.dispatch('workorders/phraseselect', {
      app_id: appid,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.phrases = res.Data;
    }
  }

  async selectPhrase(val: any) {
    // this.value = val
    this.form.setFieldsValue({
      content: val
    });
  }

  async loadData() {
    this.listloading = true;

    const res = await this.$store.dispatch('workorders/getComments', {
      subject_id: this.editId
    });
    if (res && res.Message && res.Message === 'success') {
      // console.log(res)
      this.data = res.Data || [];
    }
    this.listloading = false;
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            this.submitting = true;

            if (Number(this.editData.category_id) === 11) {
              values.content = `场馆招牌照片：${values.BOOKING_THUMBNAILS_STATUS}`;

              if (values.BOOKING_THUMBNAILS_STATUS_CONTENT) {
                values.content += `，原因：${
                  values.BOOKING_THUMBNAILS_STATUS_CONTENT || ''
                }`;
              }

              values.content += `，场馆内部展示图：${values.BOOKING_MEDIA_STATUS}`;

              if (values.BOOKING_MEDIA_STATUS_CONTENT) {
                values.content += `，原因：${
                  values.BOOKING_MEDIA_STATUS_CONTENT || ''
                }`;
              }
            } else if (Number(this.editData.category_id) === 15) {
              values.content = `场馆公告：${values.ANNOUNCEMENT_STATUS}`;
              if (values.ANNOUNCEMENT_STATUS_CONTENT) {
                values.content += `，原因${
                  values.ANNOUNCEMENT_STATUS_CONTENT || ''
                }`;
              }1
            } else if (Number(this.editData.category_id) === 16) {
              values.content = `创建场馆：${values.CREATE_STATUS}`;
              if (values.CREATE_STATUS_CONTENT) {
                values.content += `，原因${values.CREATE_STATUS_CONTENT || ''}`;
              }
            }

            const res = await this.$store.dispatch('workorders/reply', {
              subject_id: this.editId,
              admin_id: this.userInfo.id,
              admin_username: this.userInfo.name,
              ...values
            });
            if (res && res.Message === 'success') {
              this.loadData();
              this.form.resetFields();

              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
            this.submitting = false;
          }
        });
      }
    });
  }

  handleChange(e: any) {
    this.value = e.target.value;
  }

  handleDemotion() {
    this.showTsConfirm({
      title: '确认信息',
      content: '你确定要把该场馆降级为电话订场吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/reduceToPhoneOnline', {
          stadium_id: this.editData.stadium_id,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  async setStadiumStatus(val: any, id: number) {
    this.showTsConfirm({
      title: '确认信息',
      content: `您确定要${val === false ? '下线' : '上线'}该场馆吗？`,
      onOk: async () => {
        if (!this.checkPermission('admin-stadium-stadium-status')) {
          this.$message.warning('没有权限');
          return;
        }

        this.stadiumStatus = val === false ? 0 : 1;

        const res = await this.$store.dispatch('stadium/stadiumstatus', {
          id,
          val
        });
        // console.log(res)
        if (res && res.Message && res.Message === 'success') {
          this.$message.success('操作成功');
        } else {
          this.$message.error('操作失败');
        }
      }
    });
  }

  renderAnnouncement(content: string) {
    if (content.indexOf('|||') !== -1) {
      const arr: string[] = content.split('|||');
      return arr[1];
    }

    return content;
  }
}
